export default __webpack_public_path__ + "static/media/AG05a.4c54d58e.mp3";